import React from "react";
import { Grid } from "@mui/material";
import { mapBoxAccessToken } from "../../app/env";
import ReactMapboxAutocomplete from "./ReactMapboxAutocomplete";
import { FormLocation } from "../trips/form/TripFormTypeConversions";
import { LOCATION_PROMPT } from "../UserVisibleStrings";
import { setSelectedWaypointInputIndex } from "../../features/Drawer/drawerSlice";
import { useDispatch } from "react-redux";

type LocationProps = {
    query: string,
    onChange: ( location: FormLocation ) => void,
    children: React.ReactNode,
    index: number,
    setIsInteractingWithTextFieldLocationInput: React.Dispatch<React.SetStateAction<boolean>>,
    backgroundColor: string,
};

export const LocationInput = ( { query,
    onChange,
    children,
    index,
    setIsInteractingWithTextFieldLocationInput,
    backgroundColor }: LocationProps ) =>
{
    const dispatch = useDispatch();
    return (
        <Grid container>
            <Grid item xs = {10} sx = {{ paddingLeft: "10px", paddingTop: "5px" }}>
                <ReactMapboxAutocomplete
                    publicKey = {mapBoxAccessToken}
                    onSuggestionSelect = {( result: string, lat: string, lng: string, valid: boolean ) =>
                    {
                        onChange( {
                            locationName: result.replace( ", United States", "" ),
                            location: {
                                longitude: parseFloat( lng ),
                                latitude: parseFloat( lat ),
                            },
                            valid: valid,
                        } );
                    }}
                    backgroundColor = {backgroundColor}
                    inputOnFocus = {() => dispatch( setSelectedWaypointInputIndex( index ) )}
                    country = "us"
                    resetSearch = {false}
                    placeholder = {LOCATION_PROMPT}
                    query = {query}
                    setIsInteractingWithTextFieldLocationInput = {setIsInteractingWithTextFieldLocationInput}
                />
            </Grid>
            <Grid item xs = {2}>
                {children}
            </Grid>
        </Grid>
    );
};
